<template>
    <div class="information_component-container statue-information">
        <h1 v-html="translate('clause_title')"></h1>
        <div v-html="translate('clause_intro')"></div>
        <h3 style="text-align: center;" v-html="translate('clause_main_header')"></h3>
        <div v-html="translate('clause_p1')"></div>
        <div v-html="translate('clause_p2')"></div>
        <div v-html="translate('clause_p3')"></div>
        <div v-html="translate('clause_p4')"></div>
        <div v-html="translate('clause_p5')"></div>

        <div class="navi-btns">
            <div @click="$router.go(-1)" class="back-btn"><span>{{translate("back_btn")}}</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Statute",
        data () {
            return {
                rodoCode: "rodo_content"
            }
        },

        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        }
    }
</script>

<style scoped>

</style>